module.exports = __webpack_public_path__ + "img/dsci0073.f136557b.jpg";